import {config} from "..";
import {signData} from "./utils";

/**
 * @return {string}
 */
function encodeQuery(data) {
	var ss = [];
	for (var k in data) {
		var v = data[k];
		if (v == null) continue;
		if (typeof v === "object") v = JSON.stringify(v);
		ss.push(encodeURI(k) + "=" + encodeURI(v));
	}
	return ss.join("&");
}
/**
 * 清理value中的null和undefined
 * @param {any} value
 */
function clear(value) {
	if (typeof value === "object" && !(value instanceof Array)) {
		var data = {};
		for (var k in value) {
			if (value[k] != null) {
				data[k] = clear(value[k]);
			}
		}
		return data;
	}
	return value;
}
/**
 * @param {FetchOpt} config
 * @returns {Promise<FetchRes>}
 */
function ajax(config) {
	if (config.cors && hdapi.cordova) return hdapi.request(config);
	var xhr = new XMLHttpRequest();
	var i18n = config.i18n || {timeout: "请求超时", error: "无法连接网络", abort: "请求中止"};
	if (config.async === undefined) config.async = true;
	try {
		xhr.open(config.method, config.url, config.async, config.username, config.password);
	} catch (e) {
		return Promise.reject(e);
	}
	config.body = config.body || config.data;
	if (typeof config.body === "object") {
		//--处理特殊数据
		if (config.body instanceof FormData);
		else if (config.body instanceof URLSearchParams) {
			// data = clear(data);
			// data = encodeQuery(data);
			if (!config.headers) config.headers = {};
			config.headers["content-type"] = "application/x-www-form-urlencoded;charset=utf-8";
		} else {
			config.body = clear(config.body);
			config.body = JSON.stringify(config.body);
			if (!config.headers) config.headers = {};
			config.headers["content-type"] = "application/json;charset=utf-8";
		}
	}
	if (config.withCredentials) xhr.withCredentials = true;
	if (config.async) xhr.timeout = config.timeout;
	if (config.responseType) xhr.responseType = config.responseType;
	if (config.headers)
		for (var k in config.headers) {
			var v = config.headers[k];
			if (v instanceof Array) for (var i = 0; i < v.length; i++) xhr.setRequestHeader(k, v[i]);
			else xhr.setRequestHeader(k, v);
		}
	if (config.onUploadProgress) xhr.upload.onprogress = config.onUploadProgress;
	if (config.onDownloadProgress) xhr.onprogress = config.onDownloadProgress;
	var res;
	var pms = new Promise(function (resolve, reject) {
		xhr.ontimeout =
			xhr.onerror =
			xhr.onabort =
				function (e) {
					reject({no: 500, config: config, msg: i18n[e.type], type: e.type});
				};
		xhr.onload = function () {
			var headers = {};
			xhr
				.getAllResponseHeaders()
				.split("\n")
				.forEach(function (s) {
					var i = s.indexOf(":");
					if (i < 0) return;
					var k = s.slice(0, i);
					var v = s.slice(i + 1).trim();
					if (headers[k] instanceof Array) headers[k].push(v);
					else if (headers[k]) headers[k] = [headers[k], v];
					else headers[k] = v;
				});
			res = {
				status: xhr.status,
				statusText: xhr.statusText,
				headers: headers,
				data: xhr.response,
			};
			resolve(res);
		};
	});
	xhr.send(config.body);
	if (config.cancelToken) config.cancelToken(xhr);
	return pms;
}

class Http {
	constructor() {
		this.middles = [ajax];
	}
	request(config) {
		return this.middles[this.middles.length - 1](config);
	}
	/**
	 * @param {string} url
	 * @param {any} [data]
	 * @param {FetchOpt} [config]
	 */
	get(url, data, config) {
		if (data) {
			data = clear(data);
			url += (url.indexOf("?") < 0 ? "?" : "&") + encodeQuery(data);
		}
		config = Object.assign({}, config);
		config.url = url;
		config.method = "get";
		return this.request(config);
	}
	/**
	 * @param {string} url
	 * @param {any} [data]
	 * @param {FetchOpt} [config]
	 */
	post(url, data, config) {
		config = Object.assign({}, config);
		config.url = url;
		config.method = "post";
		config.body = data;
		return this.request(config);
	}
	/**
	 * @param {FetchMiddle} fn
	 */
	use(fn) {
		var prev = this.middles[this.middles.length - 1];
		this.middles.push(function (config) {
			return fn(config, prev);
		});
		return this;
	}
	create() {
		return new Http();
	}
}
var http = new Http();

// 接口模块
http.use(function (config, next) {
	return next(config).then(function (res) {
		if (res.status == 404) return Promise.reject({code: 404, msg: "接口不存在"});
		if (res.status == 500) return Promise.reject({code: 500, msg: "系统故障", config: config});
		if (/json/.test(res.headers["content-type"]))
			try {
				return JSON.parse(res.data);
			} catch (e) {
				// return res;
			}
		return res.data;
	});
});

// 签名+错误判断
http.use(function (conf, next) {
	let pms = Promise.resolve();
	if (conf.method == "post") {
		if (!conf.body) conf.body = {};
		pms = signData(conf.body);
	}
	if (!/^https?:/.test(conf.url)) {
		conf.url = config.apiDomain + (conf.url[0] == "/" ? conf.url : "/" + conf.url);
	}
	return pms
		.then(() => next(conf))
		.then((res) => {
			if (conf.allcode || res.code == config.code) {
				return res;
			}
			return Promise.reject(res);
		});
});

export default http;
